<template>
	<picture>
		<client-only>
			<v-img
				aspect-ratio="1"
				:class="extraClass"
				:src="source"
				v-bind="$attrs"
			>
				<template v-slot:placeholder>
					<v-row
						class="fill-height ma-0"
						align="center"
						justify="center"
					>
						<v-progress-circular
							aria-label="Image loading"
							indeterminate
							color="grey lighten-5"
						/>
					</v-row>
				</template>
			</v-img>
			<img
				:alt="$attrs.alt"
				:src="source"
				style="opacity: 0; position: fixed; top: -100%;"
				:class="{'no-download': !$attrs.download && $attrs.download !== '', 'download': $attrs.download || $attrs.download === ''}"
			>
		</client-only>
	</picture>
</template>

<style lang="scss" scoped>
// picture {
// 	position: relative;
// }
.no-download {
	z-index: -1;
	pointer-events: none;
}
.download {
	position: absolute !important;
	width: 100%;
	top: 0 !important;
}
picture.left ::v-deep .v-image__image.v-image__image--cover {
	background-position: left !important;
}
</style>

<script>

export default {
	props: {
		src: {
			type: String,
			default: () => null
		},
		storage: {
			type: String,
			default: () => null
		}
	},
	data:() => ({
		extraClass: null,
		source: null
	}),
	watch: {
		src (newVal) {
			this.source = newVal ? `${window.location.origin}/${newVal}` : '/lazy.jpg'
		},
		storage (newVal) {
			this.source = newVal
		}
	},
	mounted() {
		// this.extraClass = this.$attrs.class ? `grey lighten-2 ${this.$attrs.class}` : 'grey lighten-2'
		this.extraClass = `grey lighten-2 ${this.$attrs['extra-class'] || ''}`
		// this.source = this.$attrs.src ? `${window.location.origin}/${this.$attrs.src}` : '/lazy.jpg'
		// if (this.$attrs.storage)
		// 	this.src = this.$attrs.storage
		this.source = this.src ? `${window.location.origin}/${this.src}` : '/lazy.jpg'
		if (this.storage)
			this.source = this.storage
	}
}

</script>
